// src/utils/performanceMonitor.js
// Utility for custom performance traces — route navigation timing,
// Firestore query duration, and component-level profiling.

import { trace } from 'firebase/performance';
import { perf } from '../firebase';

/**
 * Start a named custom trace. Returns an object with `stop()`.
 * Usage:
 *   const t = startTrace('load_dashboard');
 *   // ...do work...
 *   t.stop();
 */
export function startTrace(name) {
  try {
    const t = trace(perf, name);
    t.start();
    return {
      putAttribute: (key, val) => {
        try {
          t.putAttribute(key, String(val));
        } catch {}
      },
      putMetric: (key, val) => {
        try {
          t.putMetric(key, val);
        } catch {}
      },
      stop: () => {
        try {
          t.stop();
        } catch {}
      },
    };
  } catch {
    // Return a no-op trace if perf SDK isn't available
    return { putAttribute: () => {}, putMetric: () => {}, stop: () => {} };
  }
}

/**
 * Track a route navigation. Call when a route change starts,
 * then call the returned `done()` when the page has rendered.
 */
export function trackRouteChange(path) {
  const t = startTrace('route_change');
  t.putAttribute('path', path);
  return { done: () => t.stop() };
}
